import { render } from "./UserEditFormModal.vue?vue&type=template&id=14a9e158&lang=pug"
import script from "./UserEditFormModal.vue?vue&type=script&lang=ts"
export * from "./UserEditFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script